import { Component, OnInit } from '@angular/core';
import { NgbActiveModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { FormValuesService } from '../services/form-values/form-values.service';

@Component({
  selector: 'app-advisor-modal',
  templateUrl: './advisor-modal.component.html',
  styleUrls: ['./advisor-modal.component.css']
})
export class AdvisorModalComponent {

  showNoMore: boolean = false;
  
  constructor( 
    public activeModal: NgbActiveModal,
  ) 
  {
    
  }

}



// WEBPACK FOOTER //
// ./src/app/advisor-modal/advisor-modal.component.ts